import { useCallback } from 'react';

import { Button, useDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

import { useAppDispatch } from 'shared/hooks';
import { setVisible } from 'shared/slices';

import { BLOCKS } from './constants';
import * as styles from './styles.css';

export const BonusStepsSection: React.FC = () => {
  const device = useDeviceType();
  const dispatch = useAppDispatch();

  const handleLoginClick = useCallback(() => {
    dispatch(setVisible(true));
  }, [dispatch]);

  const btnSize = device === 'phone' ? 'M' : 'L';

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Как получить бонусы?</div>
      <div className={styles['blocks']}>
        {BLOCKS.map(block => (
          <div className={styles['block']} key={block.id}>
            <div className={styles['block-step']}>{block.id}</div>
            <div className={styles['block-title']}>{block.text}</div>
            <img className={styles['block-image']} src={block.image} alt={block.text} />
          </div>
        ))}
      </div>
      <div className={styles['cta-wrap']}>
        <Button fullWidth size={btnSize} onClick={handleLoginClick}>
          Войти на Циан
        </Button>
      </div>
    </div>
  );
};
